import { useTranslation } from 'react-i18next'

import Button from '@/components/Button/Button'
import UIText from '@/components/UI/UIText'

export type LoadingIntroProps = {
  onStart: () => void
}

export default function LoadingIntro({ onStart }: LoadingIntroProps) {
  const { t } = useTranslation()
  const items = t('misc.intro.steps', { returnObjects: true }) as string[]

  return (
    <div className='container'>
      <div className='col-start-1 col-span-10 lg:col-start-3 lg:col-span-8 flex flex-col gap-20 items-center'>
        <UIText
          delay={0.3}
          is='h2'
          className='text-center text-18 md:text-24 font-semibold'
          i18nKey='misc.intro.title'
        />

        <ul className='flex flex-col gap-20'>
          {items?.map((item, index) => (
            <UIText delay={0.3 + 0.1 * (index + 1)} is='li' className='text-center text-16 md:text-20' i18nKey={item} />
          ))}
        </ul>

        <Button
          appear
          appearDelay={0.4 + 0.1 * items.length}
          className='pointer-events-auto mt-[12px] md:mt-[26px]'
          onClick={onStart}
        >
          {t('misc.intro.cta')}
        </Button>
      </div>
    </div>
  )
}
